import { PurchaseTransactionRepository } from '@domain/purchase-transaction/repositories/purchase-transaction.repository';
import { PurchaseTransactionRepositoryService } from '../repositories/purchase-transaction.service';

export const PurchaseTransactionProvider = [
  {
    provide: PurchaseTransactionRepository,
    useClass: PurchaseTransactionRepositoryService,
  },
];
